import request from '@/utils/request'


//查询询价统计报表数据
export function homeAllResult(query) {
  return request({
    url: '/activityXunjia/activityXunjia/home',
    method: 'get',
    params: query
  })
}

//用户出价额日统计
export function userchujiaChart(query) {
  return request({
    url: '/activityXunjia/activityXunjia/userchujiaChart',
    method: 'get',
    params: query
  })
}
//出价活动排行榜
export function starActivity(query) {
  return request({
    url: '/activityXunjia/activityXunjia/starActivity',
    method: 'get',
    params: query
  })
}